import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyState } from './company.reducer';

export const selectDataState = createFeatureSelector<CompanyState>('Company');

export const getCompanyData = createSelector(
  selectDataState,
  (state: CompanyState) => state
);
export const getLoadingState = createSelector(
  selectDataState,
  (state: CompanyState) => state.isLoading
);

export const getDeletedStatus = createSelector(
  selectDataState,
  (state: CompanyState) => state.isDeleted
);

export const getLoadError = createSelector(
  selectDataState,
  (state: CompanyState) => state.loadError
);
export const getDeleteError = createSelector(
  selectDataState,
  (state: CompanyState) => state.deleteError
);
export const getAddEditError = createSelector(
  selectDataState,
  (state: CompanyState) => state.addEditError
);
